import classnames from 'classnames';
import { SfaSponsorPillProps } from './sfaSponsorPill.types';
import styles from './sfaSponsorPill.module.scss';

const SfaSponsorPill = ({
  nativeProps = {},
  classNames = [],
  testId = 'sfa-sponsor-pill',
  label,
  sponsorLogo,
}: SfaSponsorPillProps) => (
  <div
    {...nativeProps}
    data-testid={testId}
    className={classnames(styles.sfaSponsorPill, classNames)}
  >
    <span className={styles.label}>{label}</span>
    <span className={styles.logo}>{sponsorLogo}</span>
  </div>
);

export default SfaSponsorPill;
